import { render, staticRenderFns } from "./upcoming-lesson-item-lesson.vue?vue&type=template&id=d8fac2c4&scoped=true"
import script from "./upcoming-lesson-item-lesson.vue?vue&type=script&lang=js"
export * from "./upcoming-lesson-item-lesson.vue?vue&type=script&lang=js"
import style0 from "./upcoming-lesson-item-lesson.vue?vue&type=style&index=0&id=d8fac2c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fac2c4",
  null
  
)

export default component.exports